import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iframe-calculator',
  templateUrl: 'iframe-calculator.component.html',
  styleUrls: ['iframe-calculator.component.scss', './../ifacss.scss']
})
export class IframeCalculatorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
